<template>
  <div class="w-full mx-auto container mt-8">
    <div class="flex justify-end w-full">
      <div class="flex items-center gap-2">
        <vs-button
          color="primary"
          @click="centerDialogVisibleg = true"
          class="rounded-lg border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-6 sm-fsize14"
        >
          + Add Course
        </vs-button>
      </div>
    </div>
    <div class="flex mt-4 gap-6 w-full">
      <div class="relative w-1/4">
        <el-input
          placeholder="Search"
          v-model="Search"
          class="rounded-none"
        ></el-input>
        <div class="absolute top-0 right-0 mt-2 mr-2">
          <feather-icon icon="SearchIcon" class="" />
        </div>
      </div>
      <div class="relative w-1/5">
        <el-select v-model="category" placeholder="Filter by Category">
          <el-option
            v-for="item in option"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative w-1/5">
        <el-select v-model="subject" placeholder="Filter by Topic">
          <el-option
            v-for="item in option1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative w-1/5">
        <el-select v-model="language" placeholder="Filter by Sub-Category">
          <el-option
            v-for="item in option2"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="relative w-32">
        <el-select v-model="sort" class="" placeholder="Sort By">
          <el-option
            v-for="item in option3"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="mt-5">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="srno" label="Sr. no" width="60">
        </el-table-column>
        <el-table-column prop="coursename" label="Course Name" width="150">
        </el-table-column>
        <el-table-column prop="category" label="Category" width="130">
        </el-table-column>
        <el-table-column prop="topics" label="Topics" width="150">
        </el-table-column>
        <el-table-column prop="subcategory" label="Sub-Category" width="190">
        </el-table-column>
        <el-table-column prop="language" label="Language" width="100">
        </el-table-column>
        <el-table-column prop="price" label="Price" width="90">
        </el-table-column>
        <el-table-column prop="lastupdated" label="Last Updated" width="110">
        </el-table-column>
        <el-table-column prop="chapters" label="Chapters" width="150">
          <div class="flex gap-2 bg-primay border-black border-2">
            <feather-icon icon="PlayIcon" />
            <span>5</span>
          </div>
        </el-table-column>
        <el-table-column prop="students" label="Students" width="100">
        </el-table-column>
        <el-table-column prop="action" label="Action" width="120">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [
        {
          srno: "1",
          coursename: "UI Design",
          category: "Design",
          topics: "User Experience",
          subcategory: "User research For Design",
          language: "English",
          price: "₹800",
          lastupdated: "31 july",
        },
      ],
    };
  },
};
</script>

<style></style>
